import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		tableData: [
			{
				name: "个验一键登录",
				use: "登录（请根据具体使用目的填写）",
				userType: "设备信息（IMEI、MAC、ANDROID_ID、DEVICE_ID、IMSI）存储的个人文件、读取手机状态和身份、网络信息、应用已安装列表",
				company: "/",
				permissions: "设备品牌、运营商信息、网络信息、应用已安装列表",
				url: ["https://e.189.cn/sdk/agreement/detail.do?hidetop=true","https://wap.cmpassport.com/resources/html/contract.html","https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true"],
				collect: "SDK本机采集"
			},
			{
				name: "中国移动SDK",
				use: "根据用户选择，为用户提供一键登录功能，在用户每次选择一键登录时使用",
				userType: "设备信息(IMSI、IDFV)设备品牌、运营商信息、网络信息、应用信息(应用名、应用版本号)",
				company: "中移互联网有限公司",
				permissions: "设备品牌、运营商信息、网络信息",
				url: "https://wap.cmpassport.com/resources/html/contract.html",
				collect: "SDK本机采集"
			},
			{
				name: "中国电信SDK|天翼SDK",
				use: "根据用户选择，为用户提供一键登录功能，在用户每次选择一键登录时使用",
				userType: "设备信息(IMSI、IDFV)设备品牌、运营商信息、网络信息、应用信息(应用名、应用版本号)",
				company: "世纪龙信息网络有限责任公司",
				permissions: "设备品牌、运营商信息、网络信息",
				url: "https://id.189.cn/html/agreement_709.html",
				collect: "SDK本机采集"
			},
			{
				name: "中国联通SDK",
				use: "根据用户选择，为用户提供一键登录功能，在用户每次选择一键登录时使用",
				userType: "设备信息(IMSI、IDFV)设备品牌、运营商信息、网络信息、应用信息(应用名、应用版本号)",
				company: "中国联合网络通信有限公司",
				permissions: "设备品牌、运营商信息、网络信息",
				url: "https://opencloud.wostore.cn/authz/resource/html/disclaimer.html",
				collect: "SDK本机采集"
			},
			{
				name: "个推SDK",
				use: "消息推送、判定网络状态，从而提供如仅在wifi下预加载内容的服务、位置相关信息将有助于我们为您提供线下场景的精细化推送，可以为您推荐更符合您需要的推送内容，减少无用推送消息对您的打扰。",
				userType: "存储的个人文件、设备信息（IMEI、IDFA、MAC、ANDROID_ID、OAID、Advertising ID、Serial Number、DEVICE_ID、IMSI、ICCID、IDFV、UAID）、网络信息（必选信息：设备平台、设备厂商、设备品牌、设备型号及系统版本、OAID、AndroidID、WIFI连接信息（SSID、BSSID）、运营商信息、DHCP；可选信息：IMEI、MAC、Google Advertising ID（GAID）、Serial Number、IMSI、ICCID、IP地址、基站信息）、位置相关信息、已安装应用列表",
				company: "每日互动股份有限公司",
				permissions: "网络信息、位置信息",
				url: "https://docs.getui.com/privacy/",
				collect: "SDK本机采集"
			},
			{
				name: "华为HMS Core SDK",
				use: "华为手机厂商推送",
				userType: "应用内标识符(ADDID、Push、Token)，设备的硬件信息(设备类型)，系统基本信息（系统类型、系统版本），系统设置信息（国家码）BSSID、WIFI、AndroidID",
				company: "华为软件技术有限公司",
				permissions: "应用内设备标识符",
				url: "https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177",
				collect: "SDK本机采集"
			},
			{
				name: "魅族 Flyme push",
				use: "魅族手机厂商推送",
				userType: "设备信息（设备名称、设备型号、地区和语言设置、设备识别码（IMEI 号码等）、设备硬件信息与状态、使用习惯、IP 地址、Mac 地址、操作系统版本）、应用信息（应用列表、应用程序版本、应用状态记录（下载、安装、更新、删除）、软件识别码、以及应用设置）、日志信息、位置信息",
				company: "珠海市魅族通讯设备有限公司",
				permissions: "位置信息",
				url: "https://static.meizu.com/resources/term/privacy8.html",
				collect: "SDK本机采集"
			},
			{
				name: "OPPO push",
				use: "OPPO手机厂商推送",
				userType: "设备相关信息（IMEI，OAID，Serial Number，IMSI，User ID，Android ID，Google Advertising ID，Region设置，设备型号，手机电量，手机操作系统版本及语言）、应用信息（如APP包名及版本号，运行状态）、网络信息",
				company: "广东欢太科技有限公司",
				permissions: "网络信息",
				url: "https://open.oppomobile.com/new/developmentDoc/info?id=10288",
				collect: "SDK本机采集"
			},
			{
				name: "vivo push",
				use: "vivo手机厂商推送",
				userType: "设备标识信息（如IMEI、EmmCID、UFSID、ANDROIDID、GUID、GAID、OPENID、VAID、OAID、RegID、加密的AndroidID）、应用软件信息（应用包名、版本号、APPID、安装、卸载、恢复出厂设置、运行状态）、设备制造商、网络信息",
				company: "维沃移动通信有限公司",
				permissions: "网络信息",
				url: "https://dev.vivo.com.cn/documentCenter/doc/652#w1-12075822",
				collect: "SDK本机采集"
			},
			{
				name: "MiPush",
				use: "小米手机厂商推送",
				userType: "设备标识OAID、加密的Android ID、设备信息（设备厂商、设备型号、设备内存、操作系统版本）、网络信息、WiFi状态",
				company: "北京小米移动软件有限公司",
				permissions: "网络信息",
				url: "https://dev.mi.com/distribute/doc/details?pId=1534",
				collect: "SDK本机采集"
			},
			{
				name: "高德开放平台",
				use: "为了向用户提供定位服务",
				userType: "位置信息（经纬度、精确位置、粗略位置）、设备信息【如IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、SSID、BSSID、基站信息、WiFi信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息、外部存储目录】、设备标识信息（IDFA、OAID）、当前应用信息（应用名、应用版本号）、设备参数及系统信息（系统属性、设备型号、操作系统、运营商信息）",
				company: "高德软件有限公司",
				permissions: "位置信息、蓝牙信息、传感器信息、网络信息",
				url: "https://lbs.amap.com/pages/privacy/",
				collect: "SDK本机采集"
			},
			// {
			// 	name: "uni-AD（数字天堂 Dcloud）",
			// 	use: "基础广告、广告投放合作，广告归因、反作弊、安全",
			// 	userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
			// 	company: "数字天堂(北京)网络技术有限公司",
			// 	permissions: "应用安装列表、位置信息、网络信息",
			// 	url: "https://doc.dcloud.net.cn/markdown-share-docs/1d821cdd3cdf2681045ec4be94bc8404/",
			// 	collect: "SDK本机采集"
			// },
			{
				name: "快手广告联盟SDK",
				use: "增强广告、广告投放、广告归因、反作弊、安全",
				userType: "设备品牌、设备型号、软件系统版本、存储信息、运营商信息、设备时区、设备语言、网络信息、设备标识（IMEI、MEID、OAID、AndroidID、IMSI、ICCID）位置信息（IP 地址、MAC地址、GPS 位置信息、基站信息、WIFI 信息）、应用安装列表、传感器信息 (加速度、重力、陀螺仪传感器)、sim卡激活信息",
				company: "北京快手科技有限公司",
				permissions: "网络信息、应用安装列表、传感器信息",
				url: ["https://u.kuaishou.com/home/detail/1220", "https://www.kuaishou.com/about/policy"],
				collect: "SDK本机采集"
			},
			{
				name: "优量汇（腾讯广点通）SDK",
				use: "增强广告、广告投放与监测归因、广告主统计投放结果、减少App崩溃、确保服务器正常运行、提升可扩展性和性能、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "SDK在静默状态下或在后台运行时，（GdtAd）优量汇SDK读取 已安装软件列表（主要是为了‌反作弊、设备识别及广告投放优化)。设备信息（设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商；IOS:设备名称、系统启动时间、系统语言、磁盘空间）；设备标识符（第三方开发者可以选择是否授权本SDK收集如下信息： Android：OAID、IMEI（Device ID）、MEID（Device ID）、Android_ID、AndroidID，由第三方开发者根据实际情况决定是否采集并传输给SDK用于设备标识符本身的有效性校验，并甄别设备环境异常，以识别设备风险、IOS：IDFV、 IDFA）；应用信息（包名、版本号、应用安装列表；Android：应用安装信息、已安装应用列表、宿主应用的进程名称、运行状态、可疑行为第三方开发者可以选择是否授权本SDK收集如下信息!）；传感器信息（Andriod：磁力、加速度、重力、陀螺仪传感器；IOS：设备姿态、压力传感器等基础信息）；广告信息（如产品交互数据、广告数据（如展示、点击、转化广告数据））；位置信息（第三方开发者可以选择是否向本SDK提供如下信息[双端]精确位置信息、Andriod：基站、附近的WIFI、连接的WIFI、SSID、BSSID）；诊断数据（如崩溃数据、性能数据）; 应用列表（包括当前已安装应用软件列表、当前或最近运行的软件列表和运行中的进程），详情见隐私政策",
				company: "深圳市腾讯计算机系统有限公司",
				permissions: "位置信息、网络信息、应用安信息、设备标识符、应用安装列表",
				url: ["https://qzs.gdtimg.com/union/res/union_cdn/page/dev_rules/ylh_sdk_privacy_statement.html", "https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983"],
				collect: "SDK本机采集"
			},
			{
				name: "穿山甲（字节跳动）",
				use: "增强广告、广告投放合作、广告归因、反作弊",
				userType: "设备信息（设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息、CPU信息、可用存储空间大小等基础信息）、AndroidID、OAID、无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址、应用信息、传感器信息（加速度传感器、陀螺仪传感器、线性加速度传感器、磁场传感器、旋转矢量传感器）、位置信息、设备标识符（如IMEI、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）（精确位置信息、粗略位置信息）",
				company: "北京巨量引擎网络技术有限公司",
				permissions: "网络信息、传感器信息、位置信息",
				url: "https://www.csjplatform.com/privacy/partner",
				collect: "SDK本机采集"
			},
			{
				name: "Sigmob SDK",
				use: "用于识别虚假设备、反作弊、广告主归因。根据不同分辨率、宽高，推送不同广告素材，避免广告包体过大。用于识别虚假设备、反作弊，用于广告主归因根据不同的国家、地区和语言推送不同的广告根据不同系统版本推送不同广告内容。用于广告主归因，避免重复安装。用于个性化推荐。用于识别虚假设备。用于个性化推荐.用于识别虚假设备。用于个性化推荐。由该SDK直接采集",
				userType: "设备标识符（【Android】：IMEI、GAID、OAID、AndroidID，【AndroidID】用于识别虚假设备、反作弊、广告主归因；【IOS】：IDFV、 IDFA）；**设备信息**：设备品牌、型号、操作系统版本、OAID、AndroidID、GAID、IMEI、分辨率等基础设备信息、**应用信息：**应用名称、应用包名、应用版本号等、**其他：**运营商信息、时区、广告业务必要信息】、设备信息： 设备品牌、型号、操作系统版本、分辨率等基础设备信息、应用信息：应用名称、应用包名、应用版本号等、其他：运营商信息、国家/时区、手机系统重启时间、磁盘空间、内存空间、sim卡信息（mcc&mnc）等、【可选信息】（开发者可以基于优化广告效果的目的选择授权给Sigmob读取）、地理位置、IDFA、【仅iOS 2.21.0以上版本】、手机系统重启时间、系统更新时间、磁盘空间、内存空间、设备名称等、**传感器信息列表**：传感器开关：线性加速度传感器、磁场传感器、旋转矢量传感器、加速度传感器、陀螺仪传感器",
				company: "北京创智汇聚科技股份有限公司",
				permissions: "网络信息、传感器信息、位置信息、设备信息、设备标识符",
				url: ["https://www.sigmob.com/policy.html", "https://doc.sigmob.com/sigmob/140/"],
				collect: "SDK本机采集，仅在前台广告展示场景下获取"
			},
			// {
			// 	name: "推啊",
			// 	use: "基础广告、识别广告、活动作弊行为；改善 SDK 崩溃率、推送个性化广告；广告投放。",
			// 	userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
			// 	company: "杭州推啊网络科技有限公司",
			// 	permissions: "位置信息、网络信息、应用安装信息",
			// 	url: "https://yun.tuia.cn/tuia/sdk/agreement/index.html",
			// 	collect: "SDK本机采集"
			// },
			{
				name: "章鱼广告",
				use: "增强广告、广告投放统计分析、反作弊、提升SDK的稳定性，减少APP的崩溃、推送个性化广告、广告归因",
				userType: "设备品牌、设备型号、设备时区、设备语言、系统版本、开发者应用名、应用版本号、应用包名、网络类型、UserAgent信息、网络状态、崩溃信息、性能数据、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、设备ID（OAID、GAID、AndroidID）、IMEI 用户授权才收集、USB调试模式、cpu、运行状态、运营商、传感器信息、掠过手势内容",
				company: "北京圣盈科技有限公司及其关联方",
				permissions: "位置信息、设备信息、传感器信息、网络信息、应用安装信息、广告信息、性能数据",
				url: "https://doc.adintl.cn/#/zh-cn/guide/UsePrivacy",
				collect: "SDK本机采集"
			},
			{
				name: "倍孜广告 (AdScope SDK)",
				use: "增强广告、广告投放策略、统计分析服务、反作弊分析、广告正常显示与交互功能的实现、广告归因、最大程度减少App崩溃、确保服务器正常运行、提升可扩展性和性能",
				userType: "设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、sim卡状态、设备的MAC地址、传感器信息、掠过手势内容、cpu、AndroidID、设备ID(国内用户OAID、海外用户GAID、AndroidID)、开发者应用名、应用版本号、应用包名、运行状态、使用数据、诊断数据",
				company: "上海倍孜网络技术有限公司",
				permissions: "位置信息、应用安装信息、设备信息、网络信息、系统信息",
				url: ["https://sdk-doc.adn-plus.com.cn/docs/Privacy_Protection","https://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy"],
				collect: "SDK本机采集"
			},
			{
				name: "泛连",
				use: "增强广告、广告投放及广告监测归因、反作弊、摇一摇广告投放、广告投放统计分析、提升SDK的稳定性，减少APP的崩溃",
				userType: "设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、IMEI、IMSI、ICCID、GAID、MEID、IDFA、IDFV、AndroidID、OAID、手机系统重启时间、设备的MAC地址、User Agent、IP地址、运营商信息、Wi-Fi状态、网络信号强度、应用版本、应用包名、应用名称、应用前后台状态、应用列表信息、加速度传感器、陀螺仪传感器、广告的展示、点击及转化等交互数据、系统崩溃数据、性能数据",
				company: "北京泛连科技有限公司及其关联方",
				permissions: "位置信息、应用安装信息、设备信息、网络信息、传感器信息、广告信息、其他信息",
				url: "https://www.adfunlink.com/doc/privacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "聚力阅盟",
				use: "增强广告、广告投放及广告监测归因、反作弊、摇一摇广告投放",
				userType: "设备型号、操作系统版本、唯一设备标识符、设备环境等软硬件特征信息；GPS位置以及WLAN接入点、蓝牙和基站等传感器信息",
				company: "杭州聚力阅盟科技有限公司",
				permissions: "位置信息、应用安装信息、设备信息、网络信息",
				url: "https://idbj.juliyuemeng.com/privacy",
				collect: "SDK本机采集"
			},
			{
				name: "Google AdMob(谷歌广告)",
				use: "增强广告、广告投放合作、广告归因、反作弊、安全",
				userType: "设备品牌、型号、操作系统版本、OAID、分辨率、IMEI、AndroidID、SIM 卡 IMSI 信息、应用名称、应用包名、应用版本号、网络信息、应用安装列表、位置信息",
				company: "上海神著信息科技有限公司",
				permissions: "位置信息、网络信息、应用安装信息",
				url: "https://policies.google.com/privacy",
				collect: "SDK本机采集"
			},
			{
				name: "百度SDK",
				use: "广告投放、广告监测、广告归因、反作弊功、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "设备信息（品牌、型号、系统版本、分辨率、网络信号强度、传感器信息，磁盘总空间、系统总内存空间、手机重启信息、手机系统更新时间等基础信息、OAID、AndroidID、日志信息、IMEI、IMSI、MEID屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商，手机网络状态，设备剩余存储空间，手机重启时间和更新时间）、应用信息、网络信息：IP地址，WiFi路由器MAC地址（BSSID）、设备的MAC地址，基站信息等相关信息、位置信息",
				company: "北京百度网讯科技有限公司",
				permissions: "网络信息、设备信息、应用安装列表（Android）、传感器信息、位置信息、广告标识符(IDFA)",
				url: "https://union.baidu.com/bqt/#/legal/policies",
				collect: "SDK本机采集"
			},
			{
				name: "京媒SDK",
				use: "广告投放、广告监测、广告归因、反作弊功",
				userType: "设备信息（IMEI、AndroidID、OAID、SN）、Mac地址、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息：IP地址，WiFi路由器MAC地址（BSSID）、设备的MAC地址，基站信息等相关信息、位置信息、陀螺仪传感器信息，加速度传感器信息",
				company: "重庆京东海嘉电子商务有限公司",
				permissions: "位置信息、设备信息、广告信息、性能数据、应用安装信息、传感器信息",
				url: "https://opendoc.jd.com/janGroup/help/agreement/privacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "鲸鸿动能SDK",
				use: "广告投放、广告监测、广告归因、反作弊功",
				userType: "设备信息（IMEI、AndroidID、OAID、SN）、Mac地址、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）、网络信息：IP地址，WiFi路由器MAC地址（BSSID）、设备的MAC地址，基站信息等相关信息、位置信息、陀螺仪传感器信息，加速度传感器信息",
				company: "华为软件技术有限公司",
				permissions: "位置信息、网络信息、设备标识符（包含OAID）、应用安装信息",
				url: "https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582",
				collect: "SDK本机采集"
			},
			{
				name: "阿里云 Log SDK",
				use: "广告投放合作、广告归因、反作弊、安全",
				userType: "设备信息、Mac地址、应用信息、设备参数及系统信息、网络信息：IP地址，无线网SSID名称、WiFi路由器MAC地址（BSSID）、设备的MAC地址、基站信息等相关信息、位置信息、陀螺仪传感器信息、加速度传感器信息、重力传感器信息",
				company: "阿里云计算有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息",
				url: "https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112131013_69952.html?spm=5176.smartservice_service_robot_chat_new.0.0.257c3a98BIU6PT",
				collect: "SDK本机采集"
			},
			{
				name: "Taku Android SDK",
				use: "广告投放合作、广告归因、反作弊、安全、减少App崩溃、提供稳定可靠的服务、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "系统版本名、系统版本号、当前应用包名、应用版本名、应用版本号、设备生产商、设备型号、分辨率、网络类型，例：WiFi/3G/4G、MNC、MCC、系统语言、时区、时间戳、user_agent信息、屏幕方向、设备id、应用安装来源、设备总内存、设备CPU核数、设备存储空间、设备CPU信息、电量信息、设备id(android_id)、imei（用户授权才收集）、oaid、mac地址、wifi ssid、imsi、gaid(google advertising id)、设备传感器信息",
				company: "广州塔酷信息科技有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息、传感器信息、广告信息、性能数据、设备标识符",
				url: "https://help.takuad.com/docs/1Mn1B7",
				collect: "SDK本机采集"
			},
			{
				name: "趣盟广告SDK",
				use: "广告投放合作、广告监测归因、广告投放统计分析、广告反作弊、减少App崩溃、提供稳定可靠的服务、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "【Android】设备品牌、型号、软件系统版本、分辨率、网络状态、加速度传感器、重力传感器等基础信息、设备的MAC地址、蓝牙地址、设备标识符（IMEI、AndroidID、OAID、IMSI、ICCID、MEID，具体字段因软硬件版本不同而存在差异）应用信息：开发者应用名、应用包名、版本号、应用前后台状态、应用安装列表等信息其他信息：运营商信息、设备时区、设备语言",
				company: "湖北捷兔信息科技有限公司",
				permissions: "位置信息、网络信息、设备信息、应用安装信息、传感器信息、广告信息、性能数据",
				url: "https://docs.jietuhb.com/android_sdk/qu-privacy-agreement.html",
				collect: "SDK本机采集"
			},
			{
				name: "Mintegral Android SDK",
				use: "广告投放合作、精准投放、广告监测归因、反作弊、广告主/广告代理进行结算（就该等个人信息处理活动而言，Mintegral作为处理者代表广告主/广告代理处理用户的个人信息）",
				userType: "①位置信息：IP地址；②设备/广告ID：国际移动设备识别码（IMEI）、安卓ID、OAID、IDFV，移动广告标识符（如苹果IDFA、谷歌广告ID及亚马逊ID）、MAC地址；③设备信息：设备生产商，设备型号，设备的操作系统信息，设备类型，设备屏幕信息，设备电池信息，设备音量及字体大小，是否为模拟器，设备网络信息，设备传感器信息，限制广告追踪（LAT）状态，手机开机时间，手机用户名摘要；④应用信息：Mintegral合作方的应用包名，应用版本和特性，是否为App Store下载，SDK版本；⑤使用数据：浏览、点击了该广告的相关信息；⑥其他信息：用户代理",
				company: "广州汇世信息科技有限公司",
				permissions: "位置信息、网络信息、应用信息、设备信息、设备/广告ID、广告信息",
				url: "https://www.mintegral.com/cn/privacy",
				collect: "SDK本机采集"
			},
			{
				name: "酷盈 Android SDK",
				use: "基于用户设备信息调整广告投放策略、基于用户设备信息分析广告行为(如广告加载、展示、点击等）、反作弊、在开发者进行广告投放，需要进行广告变现策略调整及数据分析时进行使用",
				userType: "必要信息：【Android+iOS+HarmonyOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、sim卡信息（mcc&mnc）、限制广告追踪（LAT）状态、CPU信息、可用存储空间大小等基础信息【Android】AndroidID、OAID【iOS】：手机系统重启时间、磁盘总空间、系统总内存空间、IDFV【HarmonyOS】ODID; 可选信息：【Android+iOS+HarmonyOS】CPU类型、设备电池电量信息、设备音量及字体大小、是否为模拟器、是否usb链接、是否开发者模式、系统启动程序版本号、硬件名称，主机地址，系统开发代号、系统源码控制版本号、设备显示的版本号、设备基板名称【Android+HarmonyOS】：国际移动设备识别码（IMEI）、MAC地址、国际移动用户识别码（IMSI）【Android】硬件序列号build_serial，具体字段因软硬件版本不同而存在差异）【iOS】：设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）【HarmonyOS】：OAID必要信息：【Android+iOS+HarmonyOS】运营商信息、Wi-Fi状态、网络信号强度;必要信息：【Android+iOS+HarmonyOS】IP地址;必要信息：【Android+HarmonyOS】Taku 合作方的应用包名、运行中的进程信息、版本号、应用前后台状态、SDK 版本号;可选信息：【Android】软件列表信息，是否为应用商店下载;可选信息：【Android】线性加速度传感器【iOS+HarmonyOS】加速度传感器、陀螺仪传感器;必选信息：【Android+iOS+HarmonyOS】对广告的展示、点击及转化等交互数据;可选信息：【Android+HarmonyOS】粗略位置信息（WLAN接入点（如SSID））;必选信息：【Android+iOS+HarmonyOS】如崩溃数据、性能数据",
				company: "广州数链通信息技术有限公司",
				permissions: "设备信息、网络信息、应用信息、传感器信息、广告信息、位置信息、设备标识信息",
				url: "https://www.statisticslinks.com/privacy-policy",
				collect: "SDK本机采集"
			},
			{
				name: "Advista广告SDK",
				use: "广告投放及广告反作弊。 其中，IMEI、IDFA、AndroidID、OAID、设备的MAC地址、设备型号还会用于广告监测归因。保证网络服务有效性及稳定性。 其中，运营商信息、Wi-Fi状态还会用于广告投放。减少App崩溃、提供稳定可靠的服务，摇一摇、扭一扭等广告投放、广告反作弊",
				userType: "设备信息（必选：【Android+iOS】设备品牌、型号、软件系统版本、屏幕密度、屏幕分辨率、设备语言、设备时区、可用存储空间大小、系统总内存空间、手机系统重启时间等基础信息【iOS】IDFV、可选：【Android+iOS】设备MAC地址（如为iOS端，则仅适用于IOS3200以下版本）【Android】设备标识符（如IMEI、AndroidID、OAID，具体字段因软硬件版本不同而存在差异）【iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异））、网络信息（必选：Android+iOS】运营商信息、Wi-Fi状态、可选：Android+iOS】IP地址）、应用信息（必选：【Android】应用包名、运行中的进程信息、版本号、应用前后台状态、可选：【Android】软件列表信息）、位置信息（可选：【Android+iOS】精确位置信息）、广告信息（必选：【Android+iOS】对广告的展示、点击及转化等交互数据）、性能数据（必选：Android+iOS】对广告的展示、点击及转化等交互数据）、传感器信息（可选：【Android+iOS】加速度传感器、陀螺仪传感器）",
				company: "上海推易软件技术有限公司",
				permissions: "设备信息、网络信息、应用信息、传感器信息、广告信息、位置信息、性能数据",
				url: "https://docs.divms.cn/guide/privacy.html",
				collect: "SDK本机采集"
			},
			{
				name: "微信开放平台",
				use: "应用内商品支付",
				userType: "设备型号、操作系统、唯一设备标识符、登录IP地址、微信软件版本号、接入网络的方式、类型和状态、网络质量数据、设备加速器（如重力感应设备）",
				company: "深圳市腾讯计算机系统有限公司",
				permissions: "设备加速器、IP地址",
				url: "https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy",
				collect: "SDK本机采集"
			},
			{
				name: "支付宝开放平台(支付宝SDK)",
				use: "应用内商品支付",
				userType: "网络信息 设备id IP地址 OAID IMSI",
				company: "支付宝(中国)网络技术有限公司",
				permissions: "网络信息 ",
				url: "https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132",
				collect: "SDK本机采集"
			},
			// {
			// 	name: "移动智能终端补充设备标识体系统一调用SDK",
			// 	use: "获取oaid、设备标识符（VAID）、设备标识符（AAID）、设备网络运营商名称、设备信息、App包名及签名信息，或在对应应用商店的APPID",
			// 	userType: "设备信息、网络信息、品牌信息、应用软件信息、设备标识符",
			// 	company: "中国信息通信研究院",
			// 	permissions: "/",
			// 	url: "https://www.msa-alliance.cn/col.jsp?id=122",
			// 	collect: "SDK本机采集"
			// },
			{
				name: "移动安全联盟 OAID（移动智能终端补充设备标识体系统一调用SDK）",
				use: "获取OAID(提供不同移动智能终端开放匿名设备标识符（OAID），用于移动安全联盟推送设备OAID生成唯一标识、广告投放合作、广告归因、反作弊、广告监测)、设备标识符（VAID）、设备标识符（AAID）、设备网络运营商名称、设备信息、App包名及签名信息，或在对应应用商店的APPID",
				// use: "获取OAID，在用户使用 APP 时收集设备 OAID 唯一标识、设备标识符（VAID）、设备标识符（AAID）、设备网络运营商名称、设备信息、App包名及签名信息，或在对应应用商店的APPID",
				userType: "设备信息、网络信息、品牌信息、应用软件信息、设备标识符(OAID)",
				company: "中国信息通信研究院",
				permissions: "/",
				url: "https://www.msa-alliance.cn/col.jsp?id=122",
				collect: "SDK本机采集",
				tips: "移动智能终端补充设备标识体系与 SDK 严格遵守我国《网络安全法》、《数据安全法》和《电信和互联网用户个人信息保护规定》等相关法律法规和《信息安全技术 个人信息安全规范》等国家标准要求。SDK 不会主动收集任何数据，只在 APP 调用时获取以下数据，用于本地判断，不会进行任何网络传输：</br></br> • 设备制造商、设备型号、设备品牌，用于判断终端调用接口</br> • 设备网络运营商名称，用于判断虚拟机环境</br> • APP 包名，用于校验签名"
			},
			{
				name: "fastjson",
				use: "无",
				userType: "JSON解析",
				company: "/",
				permissions: "/",
				url: "https://github.com/alibaba/fastjson",
				collect: "SDK本机采集"
			},
			{
				name: "glide图库",
				use: "存储的个人文件",
				userType: "用于图片预览使用",
				company: "/",
				permissions: "存储的个人文件",
				url: "http://bumptech.github.io/glide/",
				collect: "SDK本机采集"
			},
			{
				name: "阿里weexSDK",
				use: "uni-app基础模块默认集成，用于渲染uniapp的nvue页面引擎",
				userType: "读取外置存储器、写入外置存储器",
				company: "/",
				permissions: "存储的个人文件",
				url: "http://doc.weex.io/zh/",
				collect: "SDK本机采集"
			},
			{
				name: "fresco图片库",
				use: "uni-app基础模块默认集成，用于nvue页面加载图片使用",
				userType: "读取外置存储器、写入外置存储器",
				company: "/",
				permissions: "存储的个人文件",
				url: "https://www.fresco-cn.org/",
				collect: "SDK本机采集"
			},
			{
				name: "netty",
				use: "网络通讯框架（https://netty.io）",
				userType: "网络信息(IP地址)",
				company: "/",
				permissions: "网络信息(IP地址)",
				url: "https://github.com/Bilibili/DanmakuFlameMaster",
				collect: "/"
			},
			{
				name: "DanmakuFlameMaster",
				use: "Android开源弹幕引擎·",
				userType: "/",
				company: "/",
				permissions: "/",
				url: "/",
				collect: "/"
			},
			{
				name: "zip4j",
				use: "Java处理zip压缩文件的完整解决方案",
				userType: "/",
				company: "/",
				permissions: "/",
				url: "/",
				collect: "/"
			},
		],
	},
	mutations: {},
	actions: {},
	modules: {}
})